import React, { useState } from 'react';
import { BACKEND_URL } from '../../Constants';
import { useNavigate } from 'react-router-dom';
// uuid is no longer needed in this component as questions are not added here
// import { v4 as uuid } from 'uuid';

const BACKEND = BACKEND_URL + '/api/chatbotai-quizzes';

const ChatbotAIQuizzesAdd = () => {
  const navigate = useNavigate();
  const [title, setTitle] = useState('');
  const [description, setDescription] = useState('');
  const [status, setStatus] = useState('Draft');
  // questions state is no longer managed directly on this page for adding
  // const [questions, setQuestions] = useState([]);
  const [quizId, setQuizId] = useState(null); // Will store the _id once the quiz is created
  const [saving, setSaving] = useState(false);
  const [message, setMessage] = useState(''); // State for temporary user feedback messages

  // Function to show temporary messages (both in console and UI)
  const showConsoleMessage = (msg) => {
    console.log(msg); // Log to console
    setMessage(msg); // Set message for UI display
    setTimeout(() => setMessage(''), 3000); // Clear message after 3 seconds
  };

  // addEmptyQuestion function removed as questions are not added here
  // const addEmptyQuestion = () => { ... };

  // deleteQuestion function removed as questions are not deleted here
  // const deleteQuestion = (qid) => { ... };

  const handleSave = async () => {
    if (!title.trim()) {
      showConsoleMessage('Please enter a quiz title.');
      return;
    }
    setSaving(true);
    showConsoleMessage('Creating quiz...');

    try {
      let currentQuizId = quizId; // Use a local variable for the ID

      // Step 1: Create the quiz if it doesn't exist yet
      // This component's primary role is to create the initial quiz entry.
      if (!currentQuizId) {
        console.log('Attempting to create new quiz...');
        const res = await fetch(BACKEND, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ title, description, status })
        });

        if (!res.ok) {
          const errorText = await res.text();
          throw new Error(`Failed to create quiz: Status ${res.status}, Body: ${errorText}`);
        }
        const data = await res.json();
        currentQuizId = data._id; // Get the newly created quiz ID
        setQuizId(currentQuizId); // Update state

        showConsoleMessage(`New quiz created with ID: ${currentQuizId}`);

        // Step 2: Redirect to the quiz editor page immediately after creation
        // This ensures the user lands on the editable page for the quiz they just created,
        // where they can then proceed to add questions.
        if (currentQuizId) {
          showConsoleMessage('✅ Quiz created successfully. Redirecting to editor...');
          navigate(`/dashboard/chatbotai-quizzes/quiz/${currentQuizId}`);
        }

      } else {
        // This 'else' block should ideally not be hit if the redirect works immediately.
        // It's kept for robustness in case a user navigates back or saves again on the /new route
        // after the quiz has been created but before the redirect completes.
        console.log(`Quiz ID already exists (${currentQuizId}). Updating quiz metadata.`);
        const res = await fetch(`${BACKEND}/${currentQuizId}`, {
          method: 'PUT',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ title, description, status })
        });
        if (!res.ok) {
          const errorText = await res.text();
          throw new Error(`Failed to update quiz metadata: Status ${res.status}, Body: ${errorText}`);
        }
        showConsoleMessage(`Quiz metadata updated for ID: ${currentQuizId}`);
        showConsoleMessage('✅ Quiz metadata updated successfully.');
      }

      // The question saving loop (Step 2 from previous version) is removed from here.
      // Questions will be added/edited on the dedicated editor page.

    } catch (err) {
      console.error('⚠️ Error saving quiz:', err);
      showConsoleMessage(`⚠️ Failed to save quiz: ${err.message}. Check console for details.`);
    } finally {
      setSaving(false);
    }
  };

  return (
    <div className="container py-4">
      <h2 className="mb-4">ChatBot AI Quizzes - Create New Quiz</h2> {/* Updated title */}

      {/* Temporary message display */}
      {message && ( // Now conditionally renders based on the 'message' state
        <div className="alert alert-info text-center" role="alert">
          {message} {/* Displays the actual message from state */}
        </div>
      )}

      {/* Quiz Meta Section */}
      <div className="card mb-4">
        <div className="card-body">
          <h4 className="mb-3">Quiz Details</h4>

          <div className="mb-3">
            <label htmlFor="quizTitle" className="form-label">Quiz Title:</label>
            <input
              id="quizTitle"
              type="text"
              className="form-control"
              value={title}
              onChange={(e) => setTitle(e.target.value)}
              placeholder="Enter quiz title"
            />
          </div>

          <div className="mb-3">
            <label htmlFor="quizDescription" className="form-label">Description:</label>
            <textarea
              id="quizDescription"
              className="form-control"
              value={description}
              onChange={(e) => setDescription(e.target.value)}
              placeholder="Brief description of the quiz"
            />
          </div>

          <div className="mb-3">
            <label htmlFor="quizStatus" className="form-label">Status:</label>
            <select
              id="quizStatus"
              className="form-control"
              value={status}
              onChange={(e) => setStatus(e.target.value)}
            >
              <option value="Draft">Draft</option>
              <option value="Published">Published</option>
            </select>
          </div>
        </div>
      </div>

      {/* Questions Editor section removed from this component */}
      {/* {questions.map((q, index) => ( ... ))} */}

      {/* Only the Save Button remains */}
      <button
        className="btn btn-success"
        onClick={handleSave}
        disabled={saving}
      >
        💾 {saving ? 'Creating Quiz...' : 'Create Quiz'}
      </button>
    </div>
  );
};

export default ChatbotAIQuizzesAdd;
